package com.solevo.dist.utils.time

import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atStartOfDayIn
import kotlinx.datetime.toLocalDateTime

fun Instant.toCurrentLocalDateTime(): LocalDateTime = toLocalDateTime(TimeZone.currentSystemDefault())
fun Instant.startOfDay(): LocalDateTime = toCurrentLocalDateTime().startOfDay()
fun LocalDateTime.startOfDay(): LocalDateTime = date.atStartOfDayIn(TimeZone.currentSystemDefault()).toCurrentLocalDateTime()
